import * as React from "react"
import {Box, Typography} from "@mui/material";

import { ImageSkuBlock } from "@components"


export default function PricingEvolutionSkuInfo({ currentSkuSelected, currentSku }) {
	return <Box>
		<ImageSkuBlock
			skuID={currentSku}
			skuName={currentSkuSelected.sku}
			isClickable={false}
			contentProps={{
				sx: { width: 1, height: "auto", borderRadius: 2, margin: "0 auto" }
			}}
		/>

		<Box sx={{ mt: 3 }}>
			<Typography variant="subtitle2">
				{currentSkuSelected.sku}
			</Typography>
			<Typography variant="caption" sx={{ display: 'block', color: "text.disabled" }}>
				Category: {currentSkuSelected.category}
			</Typography>
			<Typography variant="caption" sx={{ display: 'block', color: "text.disabled" }}>
				Brand: {currentSkuSelected.brand}
			</Typography>

			{ !!currentSkuSelected.ean && <Typography variant="caption" sx={{ display: 'block', color: "text.disabled" }}>
				EAN: {currentSkuSelected.ean}
			</Typography> }
		</Box>
	</Box>
}